import { render, staticRenderFns } from "./ByVersion.vue?vue&type=template&id=518f4eef&scoped=true"
import script from "./ByVersion.vue?vue&type=script&lang=js"
export * from "./ByVersion.vue?vue&type=script&lang=js"
import style0 from "./ByVersion.vue?vue&type=style&index=0&id=518f4eef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f4eef",
  null
  
)

export default component.exports